import {Head} from '@aboutyou/head-elements';
import React from 'react';

function script() {
  Object.freeze(CanvasRenderingContext2D.prototype);
}

export const AdBlockDetection: React.FC = () => {
  return (
    <Head>
      <script>{`(${script.toString()})()`}</script>
    </Head>
  );
};
